import { format } from 'date-fns';
import { es } from 'date-fns/locale';
import { useFilters } from '@/lib/filterContext';
import { resolvePeriod } from '@/lib/period';

/** Rango de fechas resuelto del periodo activo (como el dashboard original). */
export function PeriodRange() {
  const { period } = useFilters();
  const { from, to } = resolvePeriod(period);
  const f = (d: string) => format(new Date(`${d}T00:00:00`), "d 'de' MMM yyyy", { locale: es });
  return (
    <span>
      {f(from)} — {f(to)}
    </span>
  );
}
